module.exports = __webpack_public_path__ + "static/media/icon-txt.2d872739.svg";